import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "base-radio__legend"
}
const _hoisted_2 = ["id", "checked", "value", "disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "base-radio__dot" }, null, -1)
const _hoisted_4 = { class: "base-radio__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("fieldset", {
    class: _normalizeClass(["base-radio", { 'base-radio--is-checked': _ctx.isAnySelected }])
  }, [
    (_ctx.legend)
      ? (_openBlock(), _createElementBlock("legend", _hoisted_1, _toDisplayString(_ctx.legend), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
      return (_openBlock(), _createElementBlock("label", {
        key: index,
        class: "base-radio__wrapper"
      }, [
        _withDirectives(_createElementVNode("input", _mergeProps({
          id: `option_${index}`,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
          class: "base-radio__input",
          type: "radio",
          checked: _ctx.isChecked(option),
          value: option.value
        }, { name: _ctx.name }, {
          disabled: option.disabled,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChange()))
        }), null, 16, _hoisted_2), [
          [_vModelRadio, _ctx.selected]
        ]),
        _hoisted_3,
        _createElementVNode("p", _hoisted_4, _toDisplayString(option.label), 1)
      ]))
    }), 128))
  ], 2))
}